import React from 'react';

import { GetStarted } from '../../components/Onboarding/GetStarted.component';

export const GetStartedPage: React.FC = () => {
  return <GetStarted />;
};
